import script from "./MatchCardComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchCardComponent.vue?vue&type=script&setup=true&lang=js"

import "./MatchCardComponent.vue?vue&type=style&index=0&id=b5b0bd3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5b0bd3c"]])

export default __exports__